import { render } from "./themeSwitcher.vue?vue&type=template&id=cbce1b86"
import script from "./themeSwitcher.vue?vue&type=script&lang=js"
export * from "./themeSwitcher.vue?vue&type=script&lang=js"

import "./themeSwitcher.vue?vue&type=style&index=0&id=cbce1b86&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__